import React, { FC } from "react";
import { DefaultButton, PrimaryButton } from "@fluentui/react";

type Props = {
  currentState: string;
  nextState: string;
  message: string;
  display: boolean;
  actionType: NextActionType;
  onClick(): void;
  onCancel(): void;
};
export enum NextActionType {
  NEXT_STATE,
  SELECT_NOMINATION,
  BACK_TO_LINE_HANDLING,
  FINISHED
}

const NextStateModal: FC<Props> = (props: Props) => {
  if (!props.display) return null;

  return (
    <div className="modal-bg">
      <div className="modal-right">
        <div id="lbl-new-state-title" className="header">
          {props.currentState} Activities
        </div>
        <div
          id="lbl-new-state-message"
          className="body"
          dangerouslySetInnerHTML={{ __html: props.message }}
        />
        <div className="footer" style={{ textAlign: "right" }}>
          <PrimaryButton
            id="btn-new-state-ok"
            onClick={props.onClick}
            className="btn-prim"
            style={{ height: 52, minWidth: 117 }}
          >
            OK
          </PrimaryButton>
          &nbsp;
          <DefaultButton
            id="btn-new-state-cancel"
            onClick={props.onCancel}
            className="btn-def"
            style={{ height: 52, minWidth: 117 }}
          >
            CANCEL
          </DefaultButton>
        </div>
      </div>
    </div>
  );
};

export default NextStateModal;
